<template>
  <v-card flat class="pa-0">
    <v-toolbar flat dense color="transparent">
      <v-toolbar-title>{{ $t('message.overtime.title') }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>

    <div class="pa-3">
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            v-model="from"
            type="date"
            dense
            outlined
            hide-details
            :label="$t('message.overtime.from')"
            @change="loadData"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="to"
            type="date"
            dense
            outlined
            hide-details
            :label="$t('message.overtime.to')"
            @change="loadData"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense class="mt-2">
        <v-col cols="4">
          <v-card outlined class="text-center pa-2" :loading="loading">
            <div class="text-caption grey--text">{{ $t('message.overtime.fifty') }}</div>
            <div class="text-h6 warning--text">{{ $formatter.formatFlexMinutes(overview.overtime_50_minutes) }}</div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card outlined class="text-center pa-2" :loading="loading">
            <div class="text-caption grey--text">{{ $t('message.overtime.hundred') }}</div>
            <div class="text-h6 error--text">{{ $formatter.formatFlexMinutes(overview.overtime_100_minutes) }}</div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card outlined class="text-center pa-2" :loading="loading">
            <div class="text-caption grey--text">{{ $t('message.overtime.total') }}</div>
            <div class="text-h6">{{ $formatter.formatFlexMinutes(overview.overtime_total_minutes) }}</div>
          </v-card>
        </v-col>
      </v-row>

      <v-card outlined class="mt-3">
        <v-card-title class="text-subtitle-1">{{ $t('message.overtime.entries') }}</v-card-title>
        <v-divider></v-divider>
        <v-list v-if="entries.length" two-line dense>
          <v-list-item v-for="entry in entries" :key="entry.time_log_id">
            <v-list-item-content>
              <v-list-item-title>{{ $formatter.formatDate(entry.date, 'YYYY-MM-DD', 'DD.MM.YYYY') }}</v-list-item-title>
              <v-list-item-subtitle>
                <v-chip x-small :color="entry.rate === 100 ? 'error' : 'warning'" text-color="white">
                  {{ entry.rate }}%
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <span>{{ $formatter.formatFlexMinutes(entry.minutes) }}</span>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-text v-else class="grey--text">{{ $t('message.overtime.noEntries') }}</v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

function pad (n) {
  return String(n).padStart(2, '0')
}
function fmt (date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export default {
  name: 'OvertimeOverview',
  data () {
    const now = new Date()
    return {
      loading: false,
      from: fmt(new Date(now.getFullYear(), now.getMonth(), 1)),
      to: fmt(new Date(now.getFullYear(), now.getMonth() + 1, 0))
    }
  },
  computed: {
    ...mapGetters('overtime', ['getOvertimeOverview']),
    overview () {
      return this.getOvertimeOverview
    },
    entries () {
      return this.overview.entries || []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('overtime', ['GET_OVERTIME_OVERVIEW']),
    loadData () {
      if (!this.from || !this.to) return
      this.loading = true
      this.GET_OVERTIME_OVERVIEW({ from: this.from, to: this.to })
        .catch(() => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.errorOccured' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
